import React, { useState, useEffect } from "react";
import axios from "axios";
import ProfilingMetrics from "./ProfilingMetrics";
import _ from "lodash";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../../../../msalConfig";
import { TELEMETRY_API } from "../../../../../../../constants/serverConfig";

const ProfilingMetricsSubOverview = (props) => {
  const objectId = props.pfdata;
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };

  const PF_SUB_API = `${TELEMETRY_API}metrics/latest?object_id=${objectId}`;

  const getprofilemetricsdata = () => {
    setIsFetching(true);
    axios.get(PF_SUB_API).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.objectId === `${objectId}`
      );
      let profilemetricdata = _.map(filteriddata, (da) => {
        return { metricValue: da.metricValue, metricKey: da.metricKey };
      });
      setData(profilemetricdata);
      setIsFetching(false);
    });
  };

  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getprofilemetricsdata(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getprofilemetricsdata(token);
          } catch (error) {}
        }
      }
    };
    fetchdatasets();
  }, [instance]);

  return (
    <>
      {" "}
      <div className="justify-content-md-center">
        <ProfilingMetrics data={data} fetching={isFetching} />
      </div>
    </>
  );
};

export default ProfilingMetricsSubOverview;
